var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tmp-contaniner"},[_c('div',[_vm._v("频道更新  即将推出")]),_c('img',{attrs:{"src":require("../assets/img/coming.png"),"alt":""}})])}]

export { render, staticRenderFns }